/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { HttpParams } from "@angular/common/http";
import { GET_USER_WHAT_IF_DATA_RESPONSE } from "./what-if.db";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class WhatIf {
	public static getUserWhatIfData(options: HttpRequestOptions) {
		const { params, pathParams } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.getUserWhatIfData.name
					)
			);

		const appId = pathParams?.["appId"] as string;

		if (!appId)
			return throwError(
				() =>
					new ApplicationError(
						"No appId parameter provided",
						this.constructor.name,
						this.getUserWhatIfData.name
					)
			);

		return of(GET_USER_WHAT_IF_DATA_RESPONSE[appId]);
	}
}
